import React, { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

const BaseCard = forwardRef(({ children, className, onClick, ...props }, ref) => {
    return (
        <div
            ref={ref}
            onClick={onClick}
            className={twMerge(
                'my-6 w-full rounded-4xl border border-theme1-cardStroke p-8 bg-theme1-white shadow-mildSubtle',
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
});

BaseCard.displayName = 'BaseCard';

export default BaseCard;
